import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-published-report',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './published-report.component.html',
  styleUrl: './published-report.component.css'
})
export class PublishedReportComponent {
  
  baseApiUrl = environment.baseApiUrl;

  constructor(private translate: TranslateService) {}

  isEnglish() {
    return this.translate.currentLang == 'en';
  }

  isKhmer() {
    return this.translate.currentLang == 'kh';
  }
  
}
